import script from "./AutoPayPauseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoPayPauseModal.vue?vue&type=script&setup=true&lang=js"

import "./AutoPayPauseModal.vue?vue&type=style&index=0&id=3ff76900&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff76900"]])

export default __exports__